module.exports = __webpack_public_path__ + "img/JavaScript.2049fdac.png";